import type { ApiSku } from "@/lib/api";
import { cn } from "@/lib/utils";

/** What a bundle contains. The savings live in the price block above it. */
export function PackageContents({ sku, className }: { sku: ApiSku; className?: string }) {
  const items = sku.packageItems ?? [];
  if (items.length === 0) return null;
  return (
    <section className={cn("rounded-xl border border-brand/20 p-4", className)}>
      <h2 className="font-medium">Termasuk dalam paket</h2>
      <ul className="mt-2 space-y-1 text-sm text-ink/80">
        {items.map((item) => (
          <li key={item.skuId} className="flex gap-2">
            <span className="tabular-nums text-ink/55">{item.qty} ×</span>
            <span>{item.sku?.label ?? "Produk"}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
